import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Hashids from "hashids";
import {apiPath, serverToken} from "../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";

function UpdateUserWallet() {

    const navigate = useNavigate()
    let {id} = useParams();


    //const userGoogleID = localStorage.getItem("G_ID")

    const hashids = new Hashids('', 10)

    const [walletBalance, setWalletBalance] = useState()
    const [user, setUser] = useState()

    const [isLoading, setIsLoading] = useState(false)
    const [isUpdatingWalletBalance, setIsUpdatingWalletBalance] = useState(false)

    const headers = {
        'Authorization': serverToken,
    };

    useEffect(() => {
        getWalletBalance()
        getUserData()
    }, []);

    const getWalletBalance = async () => {

        let decodedID = hashids.decode(id)

        setIsLoading(true)

        try {
            const res = await axios.get(apiPath + '/get-user-wallet-balance/' + decodedID[0], {headers})
            setWalletBalance(res.data.wallet.balance);
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }

    const getUserData = async () => {

        let decodedID = hashids.decode(id)

        try {
            const res = await axios.get(apiPath + '/get-user/' + decodedID, {headers})
            setUser(res.data.user)
        } catch (err) {
        }
    }

    if (isLoading) {
        return (
            <div className="container mx-auto h-screen flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    const updateWalletBalance = async () => {

        if (!isNumber(walletBalance)) {
            alert('Debe poner un valor válido')
            return
        }

        setIsUpdatingWalletBalance(true)

        const updateUserWalletData = {
            email: user.email,
            balance: walletBalance,
        }

        try {
            const result = await axios.post(apiPath + '/update-wallet-balance', updateUserWalletData, {headers})
            setWalletBalance(result.data.balance)
            setIsUpdatingWalletBalance(false)
            navigate(-1)
        } catch (error) {
            alert(error.message)
            setIsUpdatingWalletBalance(false)
        }


    }

    return (
        <div className="flex items-center justify-center py-8 px-4">

            <div className="w-full md:w-1/2 rounded-md shadow-sm py-8 px-5 dark:bg-gray-600 bg-white">

                <div className="relative flex pb-5 items-center">
                    <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    <p className="flex-shrink mx-4 text-gray-600 dark:text-gray-100">Editar saldo de la billetera</p>
                    <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                </div>

                <p className="mt-5 mb-2">Saldo actual</p>
                <input type="number" className="w-full outline-none bg-gray-100 mb-5 py-2 px-3 rounded"
                       onChange={(e) => setWalletBalance(parseFloat(e.target.value))}
                       value={walletBalance}/>

                <div className="flex justify-end mt-5 gap-x-4">

                    <button
                        onClick={() => navigate(-1)}
                        className="px-10 py-2 bg-white border hover:bg-gray-100 text-gray-800 rounded-full">Cancelar
                    </button>

                    <button
                        onClick={() => updateWalletBalance()} disabled={isUpdatingWalletBalance}
                        className={isUpdatingWalletBalance ? 'px-10 py-2 bg-sky-500 text-white rounded-full' : 'px-10 py-2 bg-sky-500 hover:bg-sky-400 text-white rounded-full'}>{isUpdatingWalletBalance ?
                        <CgSpinner className="w-7 h-7 animate-spin text-gray-white"/> : 'Actualizar'}
                    </button>

                </div>

            </div>


        </div>
    );
}

export default UpdateUserWallet;